import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-library-list-item',
    templateUrl: './library-list-item.component.html',
    styleUrls: ['./library-list-item.component.scss'],
    standalone: false
})
export class LibraryListItemComponent implements OnInit {

  @Input() libraryItemData: LibraryItemData

  constructor() {}

  ngOnInit(): void {}
}

export class LibraryItemData {
  columns: LibraryItemColumn[] = []
}

export class LibraryItemColumn {
  label: string
  data: string
}